import { BlobServiceClient, ContainerClient } from "@azure/storage-blob";
import React, { MouseEventHandler } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { sunbScribeOnClick } from "../../../services/globalEventHandler";
import { Button } from "../../components/Button";
import CampaignStatistic from "../../components/campaignStatistic/CampaignStatistic";
import { SmallModal } from "../../components/sideModal/Modal";
import SvgSelector from "../../components/svgSelector/SvgSelector";
import InnerLayout from "../innerLayout/InnerLayout";
import "./Dashboard.css";
import Timeline, { TodayMarker, TimelineMarkers} from 'react-calendar-timeline';
import 'react-calendar-timeline/lib/Timeline.css';
import moment from 'moment';
import { CampaignsStatistic, DashboardData, DashboardResponse, getDashboardDiagramItems, Statistic } from "../../../api/dashboardApi";
import { CampaignStatus } from "../../../api/campaingsApi";
import PlayerStatistic from "../../components/playerStatistic/PlayerStatistic";
import { Guid } from "../../../api/baseApi";
import { MultiValue } from "react-select";
import Select from "react-select";
import GlobalSpinner from "../../components/globalsSpinner/GlobalSpinner";


export interface DashboardProps  extends RouteComponentProps<any>
{
    logOut : () => void;
    toogleCollapse : () => void;
    isCollapsed: boolean
}

export type DashboardState = {
    i : number;
    file: any;
    showSmallModal: boolean;
    dashboardData?: {channels: DashboardResponse[]},
    statistic: Statistic,
    channelsForFilter: Option<Guid>[],
    selectedChannelsId: Guid[],
    campaignsForFilter: Option<Guid>[],
    selectedCampaignsName: Guid[],
    isLoading: boolean
}

type Option<T> = { value: T, label: string} 

export class Dashboard extends React.Component<DashboardProps, DashboardState> {
    constructor(props: DashboardProps) {
        super(props);
        this.state = { 
            i : 1, 
            file: null,
            showSmallModal: false,
            statistic: {
                total: 1,
                expired: 1,
                active: 1,
                paused: 1,
                draft: 1,
                scheduled: 1
            },
            channelsForFilter: [],
            selectedChannelsId: [],
            campaignsForFilter: [],
            selectedCampaignsName: [],
            isLoading: false,
        };
    }  

    override async componentWillMount(){
        this.setState({isLoading:true});
        await Promise.all([this.updateDashboard()])
        this.setState({isLoading:false});
    }

    updateDashboard = async () => {
        let dashboardDiagramItemsResponse = await getDashboardDiagramItems();
        if( dashboardDiagramItemsResponse.type === "succes"){
            let channelsForFilter = dashboardDiagramItemsResponse.data.data.channels.map(it => {
                return {value: it.channelId, label: it.channel}
            })

            let campaignsArray:Option<Guid>[] = [];
            dashboardDiagramItemsResponse.data.data.channels.map(channel => channel.campaigns.map( (campaign, index) => {
                campaignsArray.push({value: `${campaign.channelId}-${index}`, label: campaign.campaign})
            }))

            this.setState({
                dashboardData: {channels :dashboardDiagramItemsResponse.data.data.channels},
                channelsForFilter: channelsForFilter,
                campaignsForFilter: campaignsArray,
                statistic: dashboardDiagramItemsResponse.data.data.campaignsStatistic
            });
        }
    }

    renderStatus = (status: CampaignStatus) => {
        switch(status){
            case CampaignStatus.Active : return '#1a8145';
            case CampaignStatus.Draft : return '#48A5FC';
            case CampaignStatus.Paused : return '#F43257';
            case CampaignStatus.Scheduled : return '#48A5FC';
            case CampaignStatus.Expired : return '#717c76';
        }
    }


    getGranttGroups = (items: DashboardData, selectedCampaigns:string[] = []) => {
        if(!!!items){
            return [];
        }

        if(selectedCampaigns.length != 0){
            let filtered = items.channels.filter( channel => channel.campaigns.some( campaign => selectedCampaigns.includes(campaign.campaign)));
            return filtered.map( it => {
                return {id: it.channelId, title: it.channel}
            })
        }

        return items.channels.map( it => {
            return {id: it.channelId, title: it.channel}
        })
    }

    getGranttItems = (items: DashboardData, selectedCampaigns:string[] = []) => {
        if(!!!items){
            return [];
        }
        let id = 0;
        let result = [];
        if(selectedCampaigns.length === 0){
            for(let channelIndex = 0; channelIndex < items.channels.length; channelIndex++){
                let channel = items.channels[channelIndex];
                for( let campaignIndex = 0; campaignIndex < channel.campaigns.length; campaignIndex++){
                    let campaign = channel.campaigns[campaignIndex];
                    for(let periodIndex = 0; periodIndex < campaign.periods.length; periodIndex++ ){
                        let period = campaign.periods[periodIndex];
                        let item = {
                            id: campaign.campaign + id,
                            group: campaign.channelId,
                            title: campaign.campaign,
                            start_time: moment(period.startDate),
                            end_time: moment(period.endDate),
                            itemProps: {
                                style: {
                                    background: this.renderStatus(campaign.status),
                                    borderRadius: '10px',
                                    borderColor: this.renderStatus(campaign.status)
                                }
                            }
                        }
                        id++;
                        result.push(item);
                    }

                }
            }
        } else {
            for(let channelIndex = 0; channelIndex < items.channels.length; channelIndex++){
                let channel = items.channels[channelIndex];
                for( let campaignIndex = 0; campaignIndex < channel.campaigns.length; campaignIndex++){
                    let campaign = channel.campaigns[campaignIndex];
                    for(let periodIndex = 0; periodIndex < campaign.periods.length; periodIndex++ ){
                        let period = campaign.periods[periodIndex];
                        let item = {
                            id: campaign.campaign + id,
                            group: campaign.channelId,
                            title: campaign.campaign,
                            start_time: moment(period.startDate),
                            end_time: moment(period.endDate),
                            itemProps: {
                                style: {
                                    background: this.renderStatus(campaign.status),
                                    borderRadius: '10px',
                                    borderColor: this.renderStatus(campaign.status)
                                }
                            }
                        }
                        if(this.state.selectedCampaignsName.includes(campaign.campaign)){
                            id++;
                            result.push(item);
                        }
                    }
    
                }
            }
        }
        return result;
    }

    onChangeSelectedChannels = (values: MultiValue<Option<Guid>>) => {
        this.setState({selectedChannelsId: values.map(it => it.value)})
    }

    onChangeSelectedCampaigns = (values: MultiValue<Option<Guid>>) => {
        this.setState({selectedCampaignsName: values.map(it => it.label)})
    }

    getDashboardDataToDisplay = (items: DashboardData) =>{
        if(this.state.selectedChannelsId.length === 0){
            return items;
        }

        return { channels: items.channels.filter( channel => this.state.selectedChannelsId.includes(channel.channelId))}
    }

    render() {
        return <InnerLayout 
                activeTab="dashboard" 
                logOut={this.props.logOut} 
                toogleCollapse={this.props.toogleCollapse}
                isCollapsed={this.props.isCollapsed}
                >
                    <>
                        <div style={{"height": "72px"}}></div>
                        <div className="filter__row">
                            <div className="filter__block">
                                <label>Networks</label>
                                <Select 
                                    options={this.state.channelsForFilter}
                                    isMulti
                                    classNamePrefix={`select`}
                                    onChange={this.onChangeSelectedChannels} 
                                /> 
                            </div>
                            <div className="filter__block">
                                <label>Campaigns</label>
                                <Select 
                                    options={this.state.campaignsForFilter}
                                    isMulti
                                    classNamePrefix={`select`}
                                    onChange={this.onChangeSelectedCampaigns} 
                                /> 
                            </div>
                        </div>
                        <div className="timeline-wrap">
                        {this.state.dashboardData && <Timeline
                            stackItems
                            groups={this.getGranttGroups(this.getDashboardDataToDisplay(this.state.dashboardData), this.state.selectedCampaignsName)}
                            items={this.getGranttItems(this.getDashboardDataToDisplay(this.state.dashboardData), this.state.selectedCampaignsName)}
                            defaultTimeStart={moment().add(-10, 'day')}
                            defaultTimeEnd={moment().add(20, 'day')}
                        >
                            <TimelineMarkers>
                                <TodayMarker date={Date.now()} interval={2000} />
                            </TimelineMarkers>
                        </Timeline>
                        }
                        </div>
                        <CampaignStatistic 
                            all={this.state.statistic.total} 
                            live={this.state.statistic.active} 
                            pause={this.state.statistic.paused} 
                            end={this.state.statistic.expired} 
                            draft={this.state.statistic.draft} 
                            scheduled={this.state.statistic.scheduled} 
                        />
                        <GlobalSpinner isShow={this.state.isLoading} />
                    </>
            </InnerLayout>
    }
}

export default withRouter(Dashboard);
